module.exports = __webpack_public_path__ + "static/media/travel.8d10cb2d.jpg";